import script from "./PreviewModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreviewModal.vue?vue&type=script&lang=ts&setup=true"

export default script